import ReportsSection from '../components/reports/ReportsSection';
import StatsSection from '../components/stats/StatsSection';
import { __ } from '@/hub-shared/utils/i18n';

type DashboardTabProps = {
  companyId: number;
  bootstrapKey: string;
};

const DashboardTab = ({ companyId, bootstrapKey }: DashboardTabProps) => (
  <>
    <section className="dashboard-tab__section">
      <h2 className="h4 dashboard-tab__section-title">{__('Historique des missions')}</h2>
      <ReportsSection companyId={companyId} bootstrapKey={bootstrapKey} />
    </section>
    <section className="dashboard-tab__section">
      <StatsSection companyId={companyId} bootstrapKey={bootstrapKey} />
    </section>
  </>
);

export default DashboardTab;
